export class DeniedPlayer {

  private static numKeys = ['userID', 'orgID', 'orgSeasonID', 'orgMemberStatusID', 'updatedBy', 'orgPlayerTypeID', 'userAge', 'clubID', 'teamID'];
  private static stringKeys = ['deniedReason', 'userEmail', 'firstName', 'lastName', 'fullName', 'userImage', 'teamName', 'gender', 'note'];
  private static dateKeys = ['dateAdded', 'updated', 'dob'];

  userID: number;
  orgID: number;
  orgSeasonID: number;
  orgMemberStatusID: number;
  dateAdded: Date;
  updated: Date;
  updatedBy: number;
  orgPlayerTypeID: number;
  deniedReason: string;
  userEmail: string;
  firstName: string;
  lastName: string;
  fullName: string;
  gender: 'f' | 'm';
  dob: Date;
  userAge: number;
  userImage: string;
  clubID: number;
  teamID: number;
  teamName: string;
  note: string;

  constructor(data) {
    DeniedPlayer.numKeys.forEach(n => this[n] = +data[n]);
    DeniedPlayer.stringKeys.forEach(s => this[s] = data[s]);
    DeniedPlayer.dateKeys.forEach(d => this[d] = new Date(data[d]));
  }

}

export class MissingInfoPlayerIssuesStatus {
  private static keys = ['birthCertPassportStatus', 'associationFormStatus', 'medicalFormStatus', 'photoStatus', 'addressStatus', 'middleNameStatus'];

  birthCertPassportStatus: boolean;
  associationFormStatus: boolean;
  medicalFormStatus: boolean;
  photoStatus: boolean;
  addressStatus: boolean;
  middleNameStatus: boolean;

  constructor(data) {
    MissingInfoPlayerIssuesStatus.keys.forEach(k => this[k] = data[k] === 'OK');
  }
}

export class DeniedPlayerIssuesStatus {

  private static keys = ['birthCertPassportStatus', 'usClubFormStatus', 'photoStatus', 'addressStatus', 'middleNameStatus', 'sorStatus', 'safeSportStatus'];

  birthCertPassportStatus: string;
  usClubFormStatus: string;
  photoStatus: string;
  addressStatus: string;
  middleNameStatus: string;
  sorStatus: string;
  safeSportStatus: string;

  constructor(data) {
    DeniedPlayerIssuesStatus.keys.forEach(k => this[k] = data[k]);
  }

}

export class DeniedPlayerInfo {

  deniedPlayer: DeniedPlayer;
  deniedPlayerIssues: DeniedPlayerIssuesStatus;

  constructor(data) {
    if (data) {
      this.deniedPlayer = new DeniedPlayer(data.deniedPlayer);
      this.deniedPlayerIssues = new DeniedPlayerIssuesStatus(data.deniedPlayerIssues);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/models/association/denied-player-info.ts